module.exports = __webpack_public_path__ + "img/users-four.de412d83.svg";